// "Shop this look": keeps a running total of the selected variants and adds every line to the cart at once.
// Without JavaScript or Standard Actions the native form posts items[] to the cart add route.
class SShopLook extends HTMLElement {
  #ac;
  #formatter;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.#formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: this.dataset.currency || 'USD',
    });
    this.addEventListener('change', () => this.#updateTotal(), opts);
    this.addEventListener('submit', (event) => this.#submit(event), opts);
    this.#updateTotal();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #selects() {
    return [...this.querySelectorAll('select[data-look-select]')];
  }

  #updateTotal() {
    let cents = 0;
    let allAvailable = true;
    for (const select of this.#selects()) {
      const option = select.selectedOptions[0];
      if (!option) continue;
      cents += Number(option.dataset.price || 0);
      if (option.disabled) allAvailable = false;
    }
    const total = this.querySelector('[data-look-total]');
    if (total) total.textContent = this.#formatter.format(cents / 100);
    const button = this.querySelector('[data-look-submit]');
    if (button) button.disabled = !allAvailable;
  }

  async #submit(event) {
    if (!window.Shopify?.actions?.updateCart) return;
    event.preventDefault();
    if (this.getAttribute('aria-busy') === 'true') return;

    const lines = this.#selects()
      .map((select) => ({ merchandiseId: select.value, quantity: 1 }))
      .filter((line) => line.merchandiseId);
    if (!lines.length) return;

    const error = this.querySelector('[data-look-error]');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    this.setAttribute('aria-busy', 'true');
    try {
      const result = await window.Shopify.actions.updateCart({ lines }, { event: { context: 'product' } });
      const message = result?.userErrors?.[0]?.message;
      if (message) throw new Error(message);
      await window.Shopify.actions.openCart?.();
    } catch (err) {
      if (error) {
        error.textContent = err?.message || this.dataset.errorMessage || '';
        error.hidden = false;
      }
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('s-shop-look')) customElements.define('s-shop-look', SShopLook);
